/**
 * @logue/reverb
 *
 * @description JavaScript Reverb effect class
 * @author Logue <logue@hotmail.co.jp>
 * @copyright 2019-2026 By Masashi Yoshikawa All rights reserved.
 * @license MIT
 * @version 1.5.2
 * @see {@link https://github.com/logue/Reverb.js}
 */

//#region node_modules/.pnpm/@thi.ng+random@4.1.48/node_modules/@thi.ng/random/arandom.js
var e = 1 / 2 ** 32, t = class {
	float(t = 1) {
		return this.int() * e * t;
	}
	probability(e) {
		return this.float() < e;
	}
	norm(t = 1) {
		return (this.int() * e - .5) * 2 * t;
	}
	normMinMax(e, t) {
		let n = this.minmax(e, t);
		return this.float() < .5 ? n : -n;
	}
	minmax(e, t) {
		return this.float() * (t - e) + e;
	}
	minmaxInt(e, t) {
		e |= 0;
		let n = (t | 0) - e;
		return n ? e + this.int() % n : e;
	}
	minmaxUint(e, t) {
		e >>>= 0;
		let n = (t >>> 0) - e;
		return n ? e + this.int() % n : e;
	}
}, n = new class extends t {
	constructor(e) {
		super(), this.rnd = e;
	}
	rnd;
	float(e = 1) {
		return this.rnd() * e;
	}
	norm(e = 1) {
		return (this.rnd() - .5) * 2 * e;
	}
	int() {
		return this.rnd() * 4294967296 >>> 0;
	}
}(Math.random), r = {
	bins: 2,
	scale: 1,
	rnd: n
}, i = (e, t, n) => {
	let r = Array(e);
	for (let i = 0; i < e; i++) r[i] = n.norm(t);
	return r;
}, a = (e) => e.reduce((e, t) => e + t, 0);
function* o(e, t) {
	let n = [e[Symbol.iterator](), t[Symbol.iterator]()];
	for (let e = 0;; e ^= 1) {
		let t = n[e].next();
		if (t.done) return;
		yield t.value;
	}
}
//#endregion
//#region node_modules/.pnpm/@thi.ng+colored-noise@1.0.132/node_modules/@thi.ng/colored-noise/blue.js
function* s(e) {
	let { bins: t, scale: n, rnd: o } = {
		...r,
		...e
	}, s = i(t, n, o);
	s.forEach((e, t) => s[t] = t & 1 ? e : -e);
	let c = 1 / t, l = a(s);
	for (let e = 0, r = -1;; ++e >= t && (e = 0)) l -= s[e], l += s[e] = r * o.norm(n), r ^= 4294967294, yield r * l * c;
}
//#endregion
//#region node_modules/.pnpm/@thi.ng+colored-noise@1.0.132/node_modules/@thi.ng/colored-noise/green.js
var c = (e) => o(s(e), s(e)), l = (e) => {
	let t = 32;
	return e &= -e, e && t--, e & 65535 && (t -= 16), e & 16711935 && (t -= 8), e & 252645135 && (t -= 4), e & 858993459 && (t -= 2), e & 1431655765 && --t, t;
};
//#endregion
//#region node_modules/.pnpm/@thi.ng+colored-noise@1.0.132/node_modules/@thi.ng/colored-noise/pink.js
function* u(e) {
	let { bins: t = 8, scale: n, rnd: o } = {
		...r,
		...e
	}, s = i(t, n, o), c = 1 / t, u = a(s);
	for (let e = 0;; e = e + 1 >>> 0) {
		let r = l(e) % t;
		u -= s[r], u += s[r] = o.norm(n), yield u * c;
	}
}
//#endregion
//#region node_modules/.pnpm/@thi.ng+colored-noise@1.0.132/node_modules/@thi.ng/colored-noise/red.js
function* d(e) {
	let { bins: t, scale: n, rnd: o } = {
		...r,
		...e
	}, s = i(t, n, o), c = 1 / t, l = a(s);
	for (let e = 0;; ++e >= t && (e = 0)) l -= s[e], l += s[e] = o.norm(n), yield l * c;
}
//#endregion
//#region node_modules/.pnpm/@thi.ng+colored-noise@1.0.132/node_modules/@thi.ng/colored-noise/violet.js
var f = (e) => o(d(e), d(e));
//#endregion
//#region node_modules/.pnpm/@thi.ng+colored-noise@1.0.132/node_modules/@thi.ng/colored-noise/white.js
function* p(e) {
	let { scale: t, rnd: n } = {
		...r,
		...e
	};
	for (;;) yield n.norm(t);
}
//#endregion
//#region node_modules/.pnpm/@thi.ng+checks@3.9.2/node_modules/@thi.ng/checks/implements-function.js
var m = (e, t) => typeof e?.[t] == "function", h = (e) => m(e, "xform") ? e.xform() : e, g = (e) => typeof e?.[Symbol.iterator] == "function", _ = (e) => e, v = class {
	value;
	constructor(e) {
		this.value = e;
	}
	deref() {
		return this.value;
	}
}, y = (e) => new v(e), b = (e) => e instanceof v, x = (e) => e instanceof v ? e : new v(e), S = (e) => e instanceof v ? e.deref() : e, C = (e, t) => [
	e,
	_,
	t
];
//#endregion
//#region node_modules/.pnpm/@thi.ng+transducers@9.6.36/node_modules/@thi.ng/transducers/push.js
function w(e) {
	return e ? [...e] : C(() => [], (e, t) => (e.push(t), e));
}
//#endregion
//#region node_modules/.pnpm/@thi.ng+transducers@9.6.36/node_modules/@thi.ng/transducers/iterator.js
function* T(e, t) {
	let n = h(e)(w()), r = n[1], i = n[2];
	for (let e of t) {
		let t = i([], e);
		if (b(t)) {
			yield* S(r(t.deref()));
			return;
		}
		t.length && (yield* t);
	}
	yield* S(r([]));
}
//#endregion
//#region node_modules/.pnpm/@thi.ng+transducers@9.6.36/node_modules/@thi.ng/transducers/compr.js
var E = (e, t) => [
	e[0],
	e[1],
	t
];
//#endregion
//#region node_modules/.pnpm/@thi.ng+transducers@9.6.36/node_modules/@thi.ng/transducers/take.js
function D(e, t) {
	return g(t) ? T(D(e), t) : (t) => {
		let n = t[2], r = e;
		return E(t, (e, t) => --r > 0 ? n(e, t) : r === 0 ? x(n(e, t)) : y(e));
	};
}
//#endregion
//#region src/Meta.ts
var O = {
	version: "1.5.2",
	date: "2026-05-17T05:21:07.564Z"
}, k = {
	blue: s,
	brown: d,
	green: c,
	pink: u,
	red: d,
	violet: f,
	white: p
}, A = {
	noise: "white",
	scale: 1,
	peaks: 2,
	randomAlgorithm: n,
	decay: 2,
	delay: 0,
	reverse: !1,
	time: 2,
	filterType: "allpass",
	filterFreq: 2200,
	filterQ: 1,
	mix: .5,
	once: !1
}, j = class e {
	static version = O.version;
	static build = O.date;
	ctx;
	wetGainNode;
	dryGainNode;
	filterNode;
	convolverNode;
	outputNode;
	options;
	isConnected;
	noise = p;
	noiseMap = k;
	constructor(e, t = {}) {
		this.ctx = e, this.options = Object.assign({}, A, t), this.wetGainNode = this.ctx.createGain(), this.dryGainNode = this.ctx.createGain(), this.filterNode = this.ctx.createBiquadFilter(), this.convolverNode = this.ctx.createConvolver(), this.outputNode = this.ctx.createGain(), this.isConnected = !1, this.filterType(this.options.filterType), this.setNoise(this.options.noise), this.buildImpulse(), this.mix(this.options.mix);
	}
	connect(e) {
		return this.isConnected && this.options.once ? (this.isConnected = !1, this.outputNode) : (this.convolverNode.connect(this.filterNode), this.filterNode.connect(this.wetGainNode), e.connect(this.convolverNode), e.connect(this.dryGainNode), e.connect(this.wetGainNode), this.dryGainNode.connect(this.outputNode), this.wetGainNode.connect(this.outputNode), this.isConnected = !0, this.outputNode);
	}
	disconnect(e) {
		return this.isConnected && (this.convolverNode.disconnect(this.filterNode), this.filterNode.disconnect(this.wetGainNode)), this.isConnected = !1, e;
	}
	mix(t) {
		if (!e.inRange(t, 0, 1)) throw RangeError("[Reverb.js] Dry/Wet ratio must be between 0 to 1.");
		this.options.mix = t, this.dryGainNode.gain.value = 1 - t, this.wetGainNode.gain.value = t, console.debug(`[Reverb.js] Set dry/wet ratio to ${t * 100}%`);
	}
	time(t) {
		if (!e.inRange(t, 1, 50)) throw RangeError("[Reverb.js] Time length of impulse response must be less than 50sec.");
		this.options.time = t, this.buildImpulse(), console.debug(`[Reverb.js] Set impulse response time length to ${t}sec.`);
	}
	decay(t) {
		if (!e.inRange(t, 0, 100)) throw RangeError("[Reverb.js] Impulse Response decay level must be less than 100.");
		this.options.decay = t, this.buildImpulse(), console.debug(`[Reverb.js] Set impulse response decay level to ${t}.`);
	}
	delay(t) {
		if (!e.inRange(t, 0, 100)) throw RangeError("[Reverb.js] Impulse Response delay time must be less than 100.");
		this.options.delay = t, this.buildImpulse(), console.debug(`[Reverb.js] Set impulse response delay time to ${t}sec.`);
	}
	reverse(e) {
		this.options.reverse = e, this.buildImpulse(), console.debug(`[Reverb.js] Inpulse response is ${e ? "" : "not "}reversed.`);
	}
	filterType(e = "allpass") {
		this.filterNode.type = this.options.filterType = e, console.debug(`[Reverb.js] Set filter type to ${e}`);
	}
	filterFreq(t) {
		if (!e.inRange(t, 20, 2e4)) throw RangeError("[Reverb.js] Filter frequrncy must be between 20 and 20000.");
		this.options.filterFreq = t, this.filterNode.frequency.value = this.options.filterFreq, console.debug(`[Reverb.js] Set filter frequency to ${t}Hz.`);
	}
	filterQ(t) {
		if (!e.inRange(t, 0, 10)) throw RangeError("[Reverb.js] Filter Q value must be between 0 and 10.");
		this.options.filterQ = t, this.filterNode.Q.value = this.options.filterQ, console.debug(`[Reverb.js] Set filter Q to ${t}.`);
	}
	peaks(e) {
		this.options.peaks = e, this.buildImpulse(), console.debug(`[Reverb.js] Set IR source noise peaks to ${e}.`);
	}
	scale(e) {
		this.options.scale = e, this.buildImpulse(), console.debug(`[Reverb.js] Set IR source noise scale to ${e}.`);
	}
	getNoise(e) {
		return [...D(e, this.noise({
			bins: this.options.peaks,
			scale: this.options.scale,
			rnd: this.options.randomAlgorithm
		}))];
	}
	setNoise(e) {
		switch (this.options.noise = e, e) {
			case "blue":
				this.noise = this.noiseMap.blue;
				break;
			case "brown":
				this.noise = this.noiseMap.brown;
				break;
			case "green":
				this.noise = this.noiseMap.green;
				break;
			case "pink":
				this.noise = this.noiseMap.pink;
				break;
			case "red":
				this.noise = this.noiseMap.red;
				break;
			case "violet":
				this.noise = this.noiseMap.violet;
				break;
			case "white":
				this.noise = this.noiseMap.white;
				break;
			default:
				this.noise = p;
				break;
		}
		this.buildImpulse(), console.debug(`[Reverb.js] Set IR generator source noise type to ${e}.`);
	}
	setRandomAlgorithm(e) {
		this.options.randomAlgorithm = e, this.buildImpulse(), console.debug("[Reverb.js] Set IR source noise generator.");
	}
	static inRange(e, t, n) {
		return e >= t && e <= n;
	}
	buildImpulse() {
		let e = this.ctx.sampleRate, t = Math.max(e * this.options.time, 1), n = e * this.options.delay, r = this.ctx.createBuffer(2, t, e), i = new Float32Array(t), a = new Float32Array(t), o = new Float32Array(1), s = new Float32Array(1), c = this.getNoise(t), l = this.getNoise(t);
		for (let e = 0; e < t; e++) {
			let r;
			e < n ? (o[0] = 0, s[0] = 0, i.set(o, e), a.set(s, e), r = this.options.reverse ?? !1 ? t - (e - n) : e - n) : r = this.options.reverse ?? !1 ? t - e : e, o[0] = (c.at(e) ?? 0) * (1 - r / t) ** this.options.decay, s[0] = (l.at(e) ?? 0) * (1 - r / t) ** this.options.decay, i.set(o, e), a.set(s, e);
		}
		r.getChannelData(0).set(i), r.getChannelData(1).set(a), this.convolverNode.buffer = r;
	}
};
//#endregion
export { j as default };
